import { render } from "./ClubsList.vue?vue&type=template&id=eb2e953c&scoped=true"
import script from "./ClubsList.vue?vue&type=script&lang=js"
export * from "./ClubsList.vue?vue&type=script&lang=js"

import "./ClubsList.vue?vue&type=style&index=0&id=eb2e953c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2e953c"]])

export default __exports__